module.exports = __webpack_public_path__ + "static/media/view6.df78c24b.jpg";